// Base URL for HTTP Cloud Functions called directly by the web client.
//
// Centralised so the deployment region can be switched in ONE place during the
// blue-green migration (us-central1 -> europe-west1), and so a future US clone
// can point at its own project via NEXT_PUBLIC_FUNCTIONS_BASE_URL.
//
// IMPORTANT: only functions that are actually DEPLOYED to europe-west1 may be
// served from an EU base. whatsappWebhook and the n8n-facing functions stay in
// us-central1 and are addressed by their own Meta/n8n config, NOT by this base.
export const FUNCTIONS_BASE =
  process.env.NEXT_PUBLIC_FUNCTIONS_BASE_URL?.replace(/\/+$/, '') ||
  'https://europe-west1-yofiplace.cloudfunctions.net';

/** Build a full function URL, e.g. fnUrl('createBooking'). */
export const fnUrl = (name: string) => `${FUNCTIONS_BASE}/${name}`;
